export default "__VITE_ASSET__DZwZWsEM__"